import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        border-top: 1px solid ${({ theme }) => theme.color.grey2};
    `,

    "Problem": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 18px;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey2};

        & > h2 {
            display: flex;
            gap: 8px;
            ${({ theme }) => theme.font.extra_small_bold};

            & > span {
                ${({ theme }) => theme.font.extra_small_bold};
                color: ${({ theme }) => theme.color.major};
            }
        }
    `,
    "ChoiceDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
    "Choice": styled.div`
        display: flex;
        gap: 8px;

        & > p {
            ${({ theme }) => theme.font.extra_small};
        }
    `,
}